export const dropdownFamiliares = (listaFamiliaresState, authState, type) => {
  let listadoFamiliares = [];

  if(Array.isArray(listaFamiliaresState.listaFamiliares.data)){
    listaFamiliaresState.listaFamiliares.data.forEach((item) => {
       // hace las alertas 
       if(type === "VerResultados"){

        listadoFamiliares.push(
          {
            id: item.id,
            nombre: item.nombre,
            paciente: item.paciente,
            familiar: true, 
            verResultados: item.tipoDerecho.verResultados
          }
        );

       } else if (type === "ManejoTurnos"){

        listadoFamiliares.push(
          {
            id: item.id,
            nombre: item.nombre,
            paciente: item.paciente,
            familiar: true,
            manejoTurnos: item.tipoDerecho.manejoTurnos
          }
        );

       } else if (type === "EditarPerfil"){
        
        listadoFamiliares.push(
          {
            id: item.id,
            nombre: item.nombre,
            paciente: item.paciente,
            familiar: true,
            edicionPerfil: item.tipoDerecho.edicionPerfil
          }
        );

       }
    })
  }
  listadoFamiliares.unshift({
    id: authState.auth?.data?.paciente?.codigo,
    nombre: authState?.auth?.data?.paciente?.nombre,
    pacienteCompleto: authState.auth?.data?.paciente,
    familiar: false
  });
  return listadoFamiliares
}
